import React from "react";
import { useOutletContext, useParams } from "react-router-dom";
import ArtworksPageComponent from "../artworks-page-component/ArtworksPageComponent";
import { IParamsId } from "./utils";

const CreatedArtworks: React.FC = () => {
  const { id }: IParamsId = useParams();
  const { profilePageContext }: any = useOutletContext();
  return (
    <ArtworksPageComponent
      queryParams={{ ownerId: id, types: ["artist"] }}
      showMap={false}
      context={profilePageContext.created}
      title={false}
    />
  );
};

export default CreatedArtworks;
